import React, { Suspense, lazy } from 'react'
import { Route } from 'react-router-dom'
import { Wrapper } from '../Components/Utils/roles'
import MainNotes from '../Views/Web/Notes/MainNotes'
import Notes from '../Views/Web/Notes'
import NoteCreate from '../Views/Web/Notes/CreateNote'
import NoteEdit from '../Views/Web/Notes/EditNote'
import NotesView from '../Views/Web/Notes/ViewNotes'



function NoteRoutes() {
  return (
  //   <Route path="mainNotes" element={
  //     <Suspense fallback={<div className=" w-full h-full flex justify-center items-center">Loading...</div>}>
  //       <MainNotes />
  //     </Suspense>
  //   }>
  //   <Route index element={<Notes />} />
  //   <Route path="CreateNotes" element={
  //     <Suspense fallback={<div className=" w-full h-full flex justify-center items-center">Loading...</div>}>
  //       <NoteCreate />
  //     </Suspense>
  //   } />
  //   <Route path="editNotes/:notesId" element={
  //     <Suspense fallback={<div className=" w-full h-full flex justify-center items-center">Loading...</div>}>
  //      <NoteEdit />
  //     </Suspense>
  //   } />
  //   <Route path="viewNotes/:notesId" element={
  //     <Suspense fallback={<div className=" w-full h-full flex justify-center items-center">Loading...</div>}>
  //       <NotesView />
  //     </Suspense>
  //   } />
  // </Route>
  <Route path="dairy" element={<MainNotes/>}>
       <Route index element={<Wrapper accessKey={"my_diary_view"}  Component={Notes} />}/>
      <Route path="create" element={<Wrapper accessKey={"my_diary_create"}  Component={NoteCreate} />}/>
      <Route path='edit/:notesId' element={<Wrapper accessKey={"my_diary_edit"}  Component={NoteEdit} />} />
      <Route path='view/:notesId' element={<Wrapper accessKey={"my_diary_view"}  Component={NotesView} />} />
  </Route>
 
  )
}

export default NoteRoutes